<template>
  <Popup :ref="(el) => popup = el"
         class="popup__lg"
         :title="$t('labels.withdrawal_whitelist')"
         @onClose="hide"
  >
    <LoaderContent ref="loader">
      <div class="row" v-if="account">
        <div v-if="!account.withdrawalWhitelistsEnabled" class="d-flex justify-content-center align-items-center gap-sm">
          <span class="me-2 text-danger">
            {{ helper.trans('labels.whitelists_disabled')}}
          </span>
          <button v-if="!isMerchantOperator" @click.prevent="enable()" type="button" class="btn btn-sm btn-outline-dark">{{ helper.trans('labels.enable')}}</button>
        </div>
        <div v-else class="d-flex align-items-center justify-content-center gap-sm">
          <span class="me-2 text-success">
            {{ helper.trans('labels.whitelists_enabled')}}
          </span>
          <button v-if="!isMerchantOperator" @click.prevent="disable()" type="button" class="btn btn-sm btn-outline-danger">{{ helper.trans('labels.disable')}}</button>
        </div>

        <div class="col-sm-12 mt-2">

          <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
            <thead>
            <tr>
              <th class="text-start p-sm">{{ helper.trans('labels.address.usdt') }}</th>
              <th class="text-start p-sm">{{ helper.trans('labels.created_at') }}</th>
              <th class="text-start p-sm">{{ helper.trans('labels.deleted_at') }}</th>
              <th class="p-sm">
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in withdrawalWhitelists">
              <td class="p">{{item.address}}</td>
              <td class="p">{{dateHelper.format(item.createdAt)}}</td>
              <td class="p">{{dateHelper.format(item.deletedAt)}}</td>
              <td class="p-sm">
                <button v-if="!item.deletedAt" type="button" @click="remove(item)" class="btn btn-sm">
                  <SvgIcon icon="delete"></SvgIcon>
                </button>
              </td>
            </tr>
            <tr v-for="item in newItems">
              <td colspan="3" class="p-sm">
                <FormInputWrapper v-slot="parentProps" :errors="getErrors(`${item.id}_address`)">
                  <input type="text" :class="parentProps.class" v-model="item.address" class="form-control form-control-sm">
                </FormInputWrapper>
              </td>
              <td class="p-sm">
                <div class="d-flex gap-sm">
                  <button type="button" @click="cancel(item)" class="btn btn-sm ">
                    <SvgIcon icon="cancel"></SvgIcon>
                  </button>
                  <button type="button" @click="save(item)" class="btn btn-sm">
                    <SvgIcon icon="save"></SvgIcon>
                  </button>
                </div>

              </td>
            </tr>
            <tr>
              <td colspan="4" v-if="!isMerchantOperator" class="p-sm">
                <button @click.prevent="add()" type="button" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize-first w-100">
                  <span class="text-capitalize-first">{{helper.trans('button.add')}}</span>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </LoaderContent>
    <ConfirmPopup ref="confirmPopup"/>
  </Popup>
</template>
<script lang="ts">
import {computed, defineComponent, ref} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import Popup from "@/apps/public/components/Popup.vue";
import {$t, helper, truncateAddress} from "@/service/CommonHelper";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import {api} from "@/service/APIClient";
import AccountDTO from "@/models/AccountDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/apps/public/components/CopyButton.vue";
import {useStore} from "vuex";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import PaginationDTO from "@/models/PaginationDTO";
import Multiselect from "vue-multiselect";
import {useNotification} from "@kyvg/vue3-notification";
import LoaderContent from "@/apps/public/components/LoaderContent.vue";
import {dateHelper} from "@/service/DateHelper";
import WithdrawalWhitelistDTO from "@/models/WithdrawalWhitelistDTO";
import TronWeb from "tronweb";
import ConfirmPopup from "@/apps/public/components/ConfirmPopup.vue";
import SvgIcon from "@/apps/public/components/SvgIcon.vue";

let id = 0;
export default defineComponent({
  methods: {$t},
  emits: ['updated'],
  components: {SvgIcon, ConfirmPopup, LoaderContent, CopyButton, LoaderButton, FormInputWrapper, Popup, Multiselect},
  setup(props, {emit}) {
    const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
    const confirmPopup = ref<InstanceType<typeof ConfirmPopup> | null>(null)
    const notification = useNotification()
    const store = useStore();
    const popup = ref<InstanceType<typeof Popup> | null>(null)

    const state = reactive({
      onHide: null as any,
      account: null as AccountDTO|null,
      newItems: [] as WithdrawalWhitelistDTO[],
      withdrawalWhitelists: [] as WithdrawalWhitelistDTO[],
      errors: {} as ValidationErrorDTO[]|any,

    });

    const onOkClick = async () => {

      hide()
    }

    const show = async (account: AccountDTO, onHide: any) => {
      state.withdrawalWhitelists = []
      state.newItems = []
      state.onHide = onHide
      state.account = account
      state.errors = {}
      loadList()
      popup.value?.show()
    }


    const loadList = async () => {
      loader.value?.load(async () => {
        state.withdrawalWhitelists = (await api.withdrawalWhitelist({
          limit: 1000,
          offset: 0
        } as PaginationDTO, {accountIds: [state.account!.id]})).items
      })
    }

    const add = async () => {
      id++;
      state.newItems.push({
        id: id,
        accountId: state.account!.id,
        address: "",
        createdAt: "",
        deletedAt: "",
        activeFrom: "",
      } as WithdrawalWhitelistDTO)
    }

    const setErrors = (id: number, data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(id + '_' + error.field)) {
          state.errors[id + '_' + error.field] = [];
        }
        state.errors[id + '_' + error.field].push(error)
      }
    }


    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    const hide = () => {
      if (state.onHide) {
        state.onHide(state.account?.withdrawalWhitelistsEnabled ?? false)
      }
      state.account = null
      popup.value?.hide()
    }

    const remove = async (item: WithdrawalWhitelistDTO) => {
      confirmPopup.value?.show({
        title: $t('labels.delete_confirm'),
        okTitle: $t('button.delete'),
        onOkClick: async () => {
          loader.value?.show()
          try {
            await api.withdrawalWhitelistDelete(item.id)
          } finally {
            loader.value?.hide()
          }
          loadList()
        }
      })
    }

    const save = async (item: WithdrawalWhitelistDTO) => {
      setErrors(item.id, [])
      let addressIsValid = true;
      try {
        let hex = TronWeb.address.toHex(item.address)
        if (!hex) {
          addressIsValid = false
        }
      } catch (e) {
        addressIsValid = false;
      }

      if (!addressIsValid) {
        setErrors(item.id, [{
          code: "INVALID_VALUE",
          field: "address",
          message: "Invalid Tron address"
        } as ValidationErrorDTO])
        return;
      }

      loader.value?.show()
      try {
        await api.withdrawalWhitelistCreate(item)
        cancel(item)
      } catch (e: any) {
        if (e.response && e.request && e.request.status === 400 && e.response.data) {
          setErrors(item.id, e.response.data)
        } else {
          console.log(e);
        }
        return
      } finally {
        loader.value?.hide()
      }
      loadList()

    }

    const cancel = async (item: WithdrawalWhitelistDTO) => {
      state.newItems = state.newItems.filter((old) => old.id !== item.id)
    }

    const enable = async () => {
      loader.value?.show()
      try {
        state.account = await api.accountWithdrawalWhitelistToggle(state.account!.id, 'enable')
        emit('updated')
      } finally {
        loader.value?.hide()
      }

    }

    const disable = async () => {
      loader.value?.show()
      try {
        state.account = await api.accountWithdrawalWhitelistToggle(state.account!.id, 'disable')
        emit('updated')
      } finally {
        loader.value?.hide()
      }

    }

    return {
      ...toRefs(state),
      numberFormatter,
      onOkClick,
      store,
      getErrors,
      popup,
      helper,
      disable,
      enable,
      remove,
      cancel,
      add,
      save,
      show,
      hide,
      loader,
      truncateAddress,
      dateHelper,
      confirmPopup,
      isMerchantOperator: computed<boolean>(() => store.getters.isMerchantOperator),
    }
  }
})
</script>
